import GamePanel from './game/game-panel'
import React, { PropTypes } from 'react'
import {Link} from 'react-router'

const AboutPage = React.createClass({

  propTypes: {
    app     : PropTypes.object.isRequired,
    history : PropTypes.object.isRequired
  },

  render() {
    return (
      <main>
        <header className="banner">
          <h1 className="banner__title">
            About Gifbowl
          </h1>
          <Link to="/" className="banner__left-action">
            <span aria-hidden="true">‹</span>
            <span className="hide-visually">Return Home</span>
          </Link>
        </header>

        <div className="pad-8 pad-4-top type-extended container container-wide">
          <p><b>TL;DR</b> : Join a game that your friend has started, divide into two teams, make some cards that include GIFs, play 3 rounds (catch-phrase-esque, charades-like, password-y), win the game, live happily ever after.</p>

          <p>For those that need the full details…</p>

          <h2>Getting Set Up </h2>

          <p><b>Players should divide themselves into two teams</b>. Typically players sit in alternating order around a circle. If you have an odd number of people, decide whether you want someone to play for each team, or if you want uneven teams. Gifbowl will assign team names for you.</p>

          <p>All players should visit <a href="http://gifbowl.com">gifbowl.com</a> on their mobile devices. Select a game organizer (probably the person with the longest-lasting phone battery and best wifi connection!). The organizer taps the “Start Game” button and tells the other players the code. All other players tap “Join Game” button and enter the game code. This allows all players to join the same game room.</p>

          <h2>Creating Cards</h2>

          <p>Once players have joined the game, they can select to create their game cards. First, give the card a name. Giphy will return a corresponding gif. Don’t like the result? Just refresh the gif. Add your card to the bowl, and create another one!</p>

          <p>Not sure what name to give your card? Be creative! A card can be anything; a celebrity, your favorite landmark, a funny movie, or an inside joke.</p>

          <p>Typically, each player submits between 5-10 cards. We’ll leave this up to you - organizers keep tabs on the number of cards that have been added to the bowl and can start the game whenever they feel they have enough. Tap “Start Game” to create the game. At this point, the organizer’s phone becomes the game controller. Want to keep tabs on the score? Keep your phone nearby!</p>

          <h2>Initiating Game Play</h2>

          <p>Gifbowl consists of three rounds of play, and each round signifies a new method of guessing. Players attempt to get their team to guess the name displayed on their card using the appropriate method.</p>

          <p><b>In Round 1</b>, Players attempt to demonstrate the name of the card by describing it in words. The player can use as many words or phrases as needed to get their team to guess it. The player should NOT mention any part of the card name, spell the name, or indicate what the name of the card sounds like.</p>

          <p><b>In Round 2</b>, Players attempt to demonstrate the name of the card by acting it out. No words or sounds can be made.</p>

          <p><b>In Round 3</b>, Players attempt to demonstrate the name of the card by uttering one word, and one word only. The player may say the word as many times as needed, but cannot change the word once used.</p>

          <p><b>During the player’s turn</b>, the player attempts to get their team to guess as many cards as possible. Each turn lasts for one minute. Tap the check mark if you get the card right. If you cheat (like talking during charades, or saying a word on the card), tap the “Oops!” button, and you’ll get deducted one point.</p>

          <p><b>Once the time runs out</b>, the player’s turn is over and any cards that haven’t been guessed are returned to the bowl. After that player’s turn, they pass the card to a player on the opposing team. The round ends once all cards have been guessed (some players may need to play twice, or might not play in a given round). Teams get one point for each correct guess.</p>

          <p><b>Once the round ends</b>, the cards are added back to the bowl, and the next round starts.</p>

          <h2>Ending the Game</h2>

          <p>At the end of the three rounds, a winning team is selected. May the best team win. And of course, if you tie, better play again to determine the true champion!</p>
        </div>

        <div className="container pad-12-bottom">
          <GamePanel app={ this.props.app } history={ this.props.history } />
        </div>
      </main>
    )
  }
})

export default AboutPage



/** WEBPACK FOOTER **
 ** ./web/static/app/components/about.jsx
 **/